import destination from '@turf/destination'

export function getArrowheadWinds (latlng, bearing: number, size: number, props?: Record<string, any>) {
  const { geometry: { coordinates: left } } = destination(latlng, size, bearing - 30, props)
  const { geometry: { coordinates: right } } = destination(latlng, size, bearing + 30, props)
  return [left, right]
}
